import { useLocation } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import "./ThankYou.css";

interface ThankYouState {
  label: string;
  buttonLabel: string;
  buttonUrl: string;
}

export function buildThankYouUrl(queryParams: QueryParameters) {
  return { pathname: "/thankyou", search: queryParams.buildUrlParamsForTelemetry() };
}

export default function ThankYou() {
  const location = useLocation();
  const state = location.state as ThankYouState;

  const onClickHandler = () => {
    if (state?.buttonUrl && state.buttonUrl.length !== 0) {
      window.location.href = state.buttonUrl;
    } else {
      window.location.href = "https://www.unilever.com";
    }
  };

  return (
    <div className="thank-you">
      <p>{state?.label}</p>
      <button className="confirm-button" type="button" onClick={onClickHandler}>
        {state?.buttonLabel}
      </button>
    </div>
  );
}
